// TextBlock.tsx
import React from 'react';
import { safeHtmlLinks } from '@/utils/links/safeHref';

export interface TextBlockProps {
    text: string;
    className?: string | undefined;
}

const TextBlock: React.FC<TextBlockProps> = ({ text, className }) => {
    return (
        <div
            className={`prose prose-p:my-0.5 dark:prose-headings:text-white survey prose-headings:text-base prose-headings:font-black [&>p]:!text-xs [&>p]:opacity-85 flex flex-col justify-start ${className}`}
            dangerouslySetInnerHTML={{ __html: safeHtmlLinks(text) }}
        />
    );
};

export default TextBlock;
